import * as React from 'react'

import Checkbox from 'components/form/checkbox'
import { AGREEMENT_TYPE, DOWNLOAD_TYPE } from '../constants'
import { DI } from 'modules'
import { currencySymbol } from 'helpers/strings'

const DownloadSliderButton = ({
  agreement,
  children,
  common,
  disabled,
  entity,
  link,
  price,
  screener,
  user,
  isRepeated,
}) => {
  const [isUsed, setUse] = React.useState(false)
  const { strings } = common
  const prefix = 'page.video.slider'
  const { download_type } = agreement?.can_download_content
  const isTopUp = download_type === DOWNLOAD_TYPE.TOP_UP
  const isFree = entity.free_access

  // Data
  const text = React.useMemo(() => {
    if (isFree) {
      return strings[`${prefix}.download.free`]
    } else if (isRepeated) {
      return strings[`${prefix}.download.again`]
    } else if (agreement.agreement_type === AGREEMENT_TYPE.ONE_OFF) {
      return `${strings[`${prefix}.buy`]} ${currencySymbol}${price}`
    }
    return strings[`${prefix}.download`]
  }, [agreement, download_type, entity, price, strings])

  // State
  const [isSftp, setCheckSftp] = React.useState(false)
  const [isConfirmTopUp, setConfirmTopUp] = React.useState(false)

  // Handlers
  const sftpToggleHandler = React.useCallback(() => setCheckSftp(p => !p), [])
  const topUpToggleHandler = React.useCallback(
    () => setConfirmTopUp(p => !p),
    []
  )

  const clickBtnHandler = () =>
    setTimeout(() => {
      setUse(true)
    }, 20)

  return (
    <>
      <input name="download_to_sftp" type="hidden" value={false} />

      {link && screener ? (
        <a
          className="button"
          href={link}
          onClick={clickBtnHandler}
          rel="noopener noreferrer"
          style={isUsed ? { pointerEvent: 'none' } : {}}
          target="_blank"
        >
          {children || text}
        </a>
      ) : (
        <button
          className="button"
          disabled={
            disabled ||
            (isTopUp && !isConfirmTopUp) ||
            isUsed ||
            (agreement.agreement_type === AGREEMENT_TYPE.ONE_OFF && !isFree)
          }
          onClick={clickBtnHandler}
          type="submit"
        >
          {children || text}
        </button>
      )}

      {isTopUp && (
        <Checkbox checked={isConfirmTopUp} onChange={topUpToggleHandler}>
          {common.strings[`${prefix}.confirm_top_up`]}
        </Checkbox>
      )}

      {user?.company?.sftp_enabled && !entity?.status && (
        <Checkbox
          checked={isSftp}
          name="download_to_sftp"
          onChange={sftpToggleHandler}
        >
          {common.strings[`${prefix}.download.sftp`]}
        </Checkbox>
      )}
    </>
  )
}

export default DI(['common'])(DownloadSliderButton)
